// Mirrors functions/src/constants/gstStates.js — for the billing-details state
// dropdown only. The server derives and validates the actual stateCode itself;
// this list is just so the picker shows real state names, not free text.
export const GST_STATES = [
  'Jammu and Kashmir', 'Himachal Pradesh', 'Punjab', 'Chandigarh', 'Uttarakhand',
  'Haryana', 'Delhi', 'Rajasthan', 'Uttar Pradesh', 'Bihar', 'Sikkim',
  'Arunachal Pradesh', 'Nagaland', 'Manipur', 'Mizoram', 'Tripura', 'Meghalaya',
  'Assam', 'West Bengal', 'Jharkhand', 'Odisha', 'Chhattisgarh', 'Madhya Pradesh',
  'Gujarat', 'Daman and Diu', 'Dadra and Nagar Haveli and Daman and Diu',
  'Maharashtra', 'Andhra Pradesh (Old)', 'Karnataka', 'Goa', 'Lakshadweep',
  'Kerala', 'Tamil Nadu', 'Puducherry', 'Andaman and Nicobar Islands',
  'Telangana', 'Andhra Pradesh', 'Ladakh',
]
